<template>
  <v-select
    v-model="newValue"
    dense
    :placeholder="placeholder"
    label=""
    :rules="rules"
    :items="items"
    item-value="value"
    item-text="label"
    chips
    persistent
    :menu-props="{ 'z-index': '1500 !important'}"
    required
    color="black"
  />
</template>

<script>
import { watch, ref } from '@vue/composition-api';

export default {
  props: {
    value: {
      type: String,
      default: null
    },
    items: {
      type: Array,
      default () {
        return [];
      }
    },
    rules: {
      type: Array,
      default () {
        return [];
      }
    },
    placeholder: {
      type: String,
      default: null
    }
  },
  setup (props, context) {
    const newValue = ref(props.value);

    // v-model
    watch(newValue, () => {
      context.emit('input', newValue.value);
    });

    watch(() => props.value, () => {
      newValue.value = props.value;
    });

    return { newValue };
  }
};
</script>
